import "react-app-polyfill/stable";
import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from "./config/MsalConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

// ⬅️ ADD THIS — MSAL initialization promise
export const msalReady = msalInstance.initialize();

async function startApp() {
  // ⬅️ WAIT for MSAL to initialize
  await msalReady;

  // Now it's safe to call MSAL APIs
  if (
    !msalInstance.getActiveAccount() &&
    msalInstance.getAllAccounts().length > 0
  ) {
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  }

  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
      msalInstance.setActiveAccount(event.payload.account);
    }
  });

  const rootElement =
    document.getElementById("root") || document.createElement("div");
  const root = createRoot(rootElement);

  root.render(
    <StrictMode>
      <Router>
        <App pca={msalInstance} />
      </Router>
    </StrictMode>
  );
}

startApp();//NOSONAR

reportWebVitals();